/// <amd-module name="TestPlanCommon/RestClient/Test" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\testmanagement\vss-test-web\testplancommon\restclient\testrun.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Test from "TestPlanCommon/Contracts/Test";

export interface ITestRestClient extends IVssRestClient {
    /**
     * Create new test run.
     * 
     * @param testRun - Run details RunCreateModel
     * @param project - Project ID or project name
     */
    createTestRun(testRun: Test.RunCreateModel, project: string): Promise<Test.TestRun>;
    /**
     * @param testSettings - 
     * @param project - Project ID or project name
     */
    createTestSettings(testSettings: Test.TestSettings, project: string): Promise<number>;
}

class TestRestClient extends RestClientBase implements ITestRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Create new test run.
     * 
     * @param testRun - Run details RunCreateModel
     * @param project - Project ID or project name
     */
    public async createTestRun(
        testRun: Test.RunCreateModel,
        project: string
        ): Promise<Test.TestRun> {

        return this.beginRequest<Test.TestRun>({
            apiVersion: "5.1-preview.3",
            method: "POST",
            routeTemplate: "{project}/_apis/test/Runs/{runId}",
            routeValues: {
                project: project
            },
            body: testRun
        });
    }

    /**
     * @param testSettings - 
     * @param project - Project ID or project name
     */
    public async createTestSettings(
        testSettings: Test.TestSettings,
        project: string
        ): Promise<number> {

        return this.beginRequest<number>({
            apiVersion: "5.1-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/test/TestSettings/{testSettingsId}",
            routeValues: {
                project: project
            },
            body: testSettings
        });
    }

}

export const TestClientName = "TestHubRefresh-Test-WebPlatform.ITestRestClient";

export function getTestClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITestRestClient {
    return pageContext.getRestClient<ITestRestClient>(TestClientName, options);
}

RestClients.add(TestClientName, { 
    factory: TestRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
